import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Clock, Award, Heart } from 'lucide-react';
const features = [{
  icon: Award,
  title: '专业认证',
  subtitle: 'Certified Professionals',
  desc: '所有技师均持有专业资格证书，经过严格筛选与培训。'
}, {
  icon: Shield,
  title: '隐私保护',
  subtitle: 'Privacy Guaranteed',
  desc: '严格保密制度，尊重每位客户的隐私与个人空间。'
}, {
  icon: Clock,
  title: '24小时服务',
  subtitle: '24/7 Available',
  desc: '全天候预约服务，无论何时何地，随时为您服务。'
}, {
  icon: Heart,
  title: '五星体验',
  subtitle: '5-Star Experience',
  desc: '超过2000+满意客户好评，致力于提供极致的放松体验。'
}];
export function WhyChooseUs() {
  return <section id="why-us" className="py-24 bg-[#1a1a2e] text-white relative overflow-hidden" data-id="element-155">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-156">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#c9a96e] blur-3xl" data-id="element-157" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-[#8b2252] blur-3xl" data-id="element-158" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-159">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-160">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-161">
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-162">
              为何选择
              <br data-id="element-163" />
              <span className="text-[#c9a96e]" data-id="element-164">幸福缘</span> ?
            </h2>
            <p className="text-xl text-gray-300 mb-8 font-light" data-id="element-165">
              Why Choose Happiness Connection?
            </p>
            <p className="text-gray-400 leading-relaxed mb-8 text-lg" data-id="element-166">
              我们致力于为您提供新加坡最高端的按摩与伴游服务。在这里，每一次体验都是一场身心的洗礼，每一刻时光都值得被珍藏。
            </p>
            <div className="w-20 h-1 bg-[#c9a96e]" data-id="element-167" />
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-168">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white/5 backdrop-blur-sm p-6 rounded-sm border border-white/10 hover:bg-white/10 transition-colors duration-300" data-id="element-169">
                <feature.icon className="text-[#c9a96e] mb-4" size={32} data-id="element-170" />
                <h3 className="text-xl font-serif font-bold text-white mb-1" data-id="element-171">
                  {feature.title}
                </h3>
                <p className="text-xs text-gray-400 uppercase tracking-wider mb-3" data-id="element-172">
                  {feature.subtitle}
                </p>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-173">
                  {feature.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}